module.exports = __webpack_public_path__ + "img/logo-vidusara-epaper.86713259.png";